
import { SupabaseClientWrapper } from './SupabaseClientWrapper';

/**
 * Base Repository Class
 * Provides common functionality for all repositories
 */
export abstract class BaseRepository {
  protected supabase: SupabaseClientWrapper;

  constructor() {
    this.supabase = new SupabaseClientWrapper();
  }

  /**
   * Get the Supabase client instance
   */
  protected getClient() {
    return this.supabase.getClient();
  }
}

/**
 * User-Scoped Repository Base Class
 * For entities that belong to specific users
 */
export abstract class UserScopedRepository extends BaseRepository {
  constructor() {
    super();
  }
}
